import SlsTracker from '@aliyun-sls/web-track-browser'
const isProd = location.hostname.indexOf('webapp.hengchiauto.com') > -1 || location.hostname.indexOf('mall.hengchiauto.com') > -1 || location.hostname.indexOf('common.hengchiauto.com') > -1
const opts = {
  host: 'cn-shenzhen.log.aliyuncs.com',
  project: isProd ? 'k8s-log-c5d7d9e5df22f4772ad734d9c23c43f77' : 'k8s-log-cf3ee33e9c35247dba6c7f5a28a2fb89d',
  logstore: 'web-log',
  time: 5, // 发送日志的时间间隔，默认是10秒。
  count: 5, // 发送日志的数量大小，默认是10条。
  topic: 'webLog',// 自定义日志主题。
  // source: 'source',
  // tags: {
  //   tags: 'tags',
  // },
}

const tracker = new SlsTracker(opts)
export default tracker

